import { GetCostPipe, ItemCostPipe } from './getCost.pipe';
import { UnitPageSubtitlePipe } from './unit-cost-subtitle.pipe';
import { UnitNamePipe } from './unitName.pipe';

export * from './getCost.pipe';
export * from './unitName.pipe';
export * from './unit-cost-subtitle.pipe';

export const FORCE_PIPES = [GetCostPipe, UnitNamePipe, ItemCostPipe, UnitPageSubtitlePipe];
